module.exports = __webpack_public_path__ + "img/crime-sq.79b8c35d.svg";